import { css } from 'styled-components';

const checkFlexGap = () => {
  // create flex container with row-gap set
  var flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';

  // create two, elements inside it
  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex.parentNode.removeChild(flex);

  return isSupported;
};

const flexGapPolyfill = (gap) => {
  return css`
    --gap: ${gap};
    --column-gap: var(--gap);
    --row-gap: var(--gap);
    margin: calc(var(--row-gap) / -2) calc(var(--column-gap) / -2);
    & > * {
      margin: calc(var(--row-gap) / 2) calc(var(--column-gap) / 2);
    }
  `;
};

export const flexGap = (gap) => {
  if (checkFlexGap()) {
    return css`
      gap: ${gap};
    `;
  }
  return flexGapPolyfill(gap);
};
